export default {
      id: "planner-file-usage",
      viewBox: "0 0 12 16",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#planner-file",
      toString: function () {
        return this.url;
      }
    }